import React from 'react'
import { useChangeMenuPageTitle, useMenuId, useTrackView } from '../../hooks'
import { useAssetsInfinite } from '../../api/query-hooks'
import { TopBodyLayout } from '../../components/top-body-layout'
import { Contact } from '../../components/connected-contact'
import { Skeleton } from '../../components/skeleton'
import styled from 'styled-components'
import { AssetCard } from '../../components/asset-card'
import { InfiniteScroll } from 'antd-mobile'

const Container = styled.div`
  padding: 2rem 1.25rem 0;
  & > * + * {
    margin-top: 1.25rem;
  }
`
const Video = styled.video`
  width: calc(100% + 1.5rem);
  margin: -0.75rem -0.75rem 0.75rem;
  vertical-align: bottom;
`
const Title = styled.div`
  font-weight: bold;
`
export const Videos: React.VFC = () => {
  useChangeMenuPageTitle()
  const menuId = useMenuId()
  const { data, hasNext, fetchNext } = useAssetsInfinite(menuId)
  const trackView = useTrackView()
  return (
    <Skeleton
      value={data}
      render={data => (
        <TopBodyLayout
          top={<Contact />}
        >
          <Container>
            {data.map(({ assertId, assertName, uploader, resource, viewCount ,fileCoverUrl}) => (
              <AssetCard
                uploader={{
                  name: uploader.name,
                  avatar: uploader.avatar
                }}
                viewCount={viewCount}
              >
                <div>
                  <Video src={resource.src} controls={true} onPlay={() => trackView(assertId)} poster={fileCoverUrl}/>
                  <Title>{assertName}</Title>
                </div>
              </AssetCard>
            ))}
            <InfiniteScroll loadMore={fetchNext} hasMore={hasNext} />
          </Container>
        </TopBodyLayout>
      )}
    />
  )
}
